import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const ReviewOverview = lazy(() => import('./review-overview'));
const ReviewCreate = lazy(() => import('./review-create/review-create.component'));
const ReviewDetail = lazy(() => import('./review-detail/review-detail.component'));
const ReviewUpdate = lazy(() => import('./review-update/review-update.component'));
const ReviewTransactionCreate = lazy(() => import('./review-detail/review-transaction-create/review-transaction-create.component'));

export function ReviewRoutes() {
    return (
        <Route path='reviews'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ReviewOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <ReviewCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':reviewId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ReviewDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ReviewUpdate />
                        </AsyncComponent>
                    }
                />
                <Route path='review-transactions'>
                    <Route
                        path='create'
                        element={
                            <AsyncComponent>
                                <ReviewTransactionCreate />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
        </Route>
    );
}
